import { LotStatus, RightsType } from 'src/constants';
import type { IApiBankLot } from 'src/interfaces';

const MAUSOLEUM_ID = '618a4a8b2fdc13169ef10fd9';
const CEMETERY_MOCK_ID = '60a265abf361acaf56e5ea59';
const BANK_A_ID = 'mock-bank-a';
const BANK_B_ID = 'mock-bank-b';
const CREATED_AT = '2022-03-31T15:13:37.845Z';

const createBankLot = ({
  id,
  bank,
  no,
  x,
  y,
  width = 1,
  height = 1,
  right = RightsType.SINGLE,
  status = LotStatus.AVAILABLE_FOR_SALE,
}: {
  id: string;
  bank: string;
  no: string;
  x: number;
  y: number;
  width?: number;
  height?: number;
  right?: RightsType;
  status?: LotStatus;
}): IApiBankLot => ({
  id,
  bank,
  cemetery: CEMETERY_MOCK_ID,
  mausoleum: MAUSOLEUM_ID,
  no,
  price: 1100000,
  right,
  row: y,
  scheme: { height, width, x, y },
  status,
  tier: x,
  type: 'niche',
  created_at: CREATED_AT,
  updated_at: CREATED_AT,
});

export const MOCK_BANK_LOTS: IApiBankLot[] = [
  createBankLot({ id: 'bank-a-lot-1', bank: BANK_A_ID, no: '101', x: 1, y: 1 }),
  createBankLot({
    id: 'bank-a-lot-2',
    bank: BANK_A_ID,
    no: '102',
    x: 2,
    y: 1,
    width: 2,
    right: RightsType.SIDE_BY_SIDE,
  }),
  createBankLot({
    id: 'bank-a-lot-3',
    bank: BANK_A_ID,
    no: '103',
    x: 1,
    y: 2,
    status: LotStatus.UNAVAILABLE,
  }),
  createBankLot({ id: 'bank-b-lot-1', bank: BANK_B_ID, no: '201', x: 1, y: 1 }),
  createBankLot({ id: 'bank-b-lot-2', bank: BANK_B_ID, no: '202', x: 2, y: 1 }),
];
